class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.input = this.querySelector('input[type="search"]');
    this.wrapper = document.querySelector('.predictive-wrapper');
    this.predictiveSearchResults = this.wrapper.querySelector('#predictive-search');
    this.spinner = this.querySelector('.spinner');
    this.searchButton = this.querySelector('#search-button');
    this.closeButton = this.querySelector('.search-reset-label');

    this.overlay = this.querySelector('.search__overlay')
    this.overlay.addEventListener('click', () => {
      this.form.removeAttribute('open');
      this.close();
    });
    this.closeButton.addEventListener('click', () => {
      this.input.setAttribute('value', '');
      this.form.removeAttribute('open');
      this.close();
    });

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 100).bind(this));

    // Add event listener to input element to open the search wrapper when focused
    this.input.addEventListener('focus', () => {
      const searchTerm = this.input.value.trim();
      // If a search has already been performed and we have a searchterm typed in, open element
      if (this.searchPerformed && searchTerm) {
        this.open(searchTerm);
        // If no search has been performed, but a search term is typed, searches and opens (onchange)
      } else if (!this.searchPerformed && searchTerm) {
        this.onChange(searchTerm)
      }
    });
    this.form.addEventListener('submit', (event) => {
      const searchTerm = this.input.value.trim();
      if (searchTerm.length > 0) {
        this.recordSearchTerm(searchTerm);
      }
    });

  }

  onChange() {
    this.spinner.classList.remove('hidden');
    this.searchButton.classList.add('hidden');
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.form.action = '/collections/all-products';
      this.close();
      return;
    }

    // this.input.addEventListener('focus', () => {
    //   this.open();
    // });

    this.form.action = '/search';
    this.getSearchResults(searchTerm);
  }

  async getSearchResults(searchTerm) {
    this.searchPerformed = true;

    try {
      const [predictiveResultsMarkup, normalResults] = await Promise.all([
        this.fetchPredictiveSearchResults(searchTerm),
        this.fetchNormalSearchResults(searchTerm)
      ]);

      // Update predictive search results
      this.predictiveSearchResults.innerHTML = predictiveResultsMarkup.trim() ? predictiveResultsMarkup : '';

      // Process and combine results
      this.processAndCombineResults(predictiveResultsMarkup, normalResults, searchTerm);

      // Open the search results
      this.open();

      // console.log('This search term', searchTerm)
      this.updateSearchHistory(searchTerm);
      // Render the search history
      this.renderSearchHistory();
    } catch (error) {
      console.error('Error fetching search results:', error);
      this.close();
    } finally {
    }
  }

  async fetchPredictiveSearchResults(searchTerm) {
    // const response = await fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`);
    const response = await fetch(`/search/suggest?q=${searchTerm}&resources[options][fields]=title,body,product_type,variants.title,vendor,variants.title,variants.sku&section_id=predictive-search`);


    if (!response.ok) {
      throw new Error(response.status);
    }
    const text = await response.text();
    return new DOMParser().parseFromString(text, 'text/html')
      .querySelector('#shopify-section-predictive-search').innerHTML;
  }

  async fetchNormalSearchResults(searchTerm) {
    const response = await fetch(`/search?q=${encodeURIComponent(searchTerm)}&view=json`);
    if (!response.ok) {
      throw new Error(response.status);
    }
    const html = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    // Extract necessary information
    const resultsCountElement = doc.querySelector('#results-count');
    const totalResults = resultsCountElement ? resultsCountElement.textContent : 0;
    const productItems = Array.from(doc.querySelectorAll('li.predictive-search__product-item'));

    return { totalResults, productItems };
  }

  processAndCombineResults(predictiveResultsMarkup, { totalResults, productItems }, searchTerm) {
    const existingProductIds = new Set();
    const predictiveSearchResultsContainer = document.querySelector('.predictive-search__product-list');

    // Extract existing product IDs from predictive search results
    const existingProductItems = Array.from(new DOMParser()
      .parseFromString(predictiveResultsMarkup, 'text/html')
      .querySelectorAll('.predictive-search__product-item[data-product-id]'));

    existingProductItems.forEach(item => existingProductIds.add(item.getAttribute('data-product-id')));

    let displayedCount = existingProductItems.length;

    // Filter out duplicates from productItems
    const uniqueProductItems = productItems.filter(item => !existingProductIds.has(item.getAttribute('data-product-id')));

    // Combine results and ensure max 6 items are displayed
    uniqueProductItems.forEach(item => {
      if (displayedCount >= 6) return;

      const productId = item.getAttribute('data-product-id');
      predictiveSearchResultsContainer.appendChild(item.cloneNode(true));
      existingProductIds.add(productId);
      displayedCount++;
    });

    if (displayedCount === 0) {
      const message = `<div class="no-results">No products could be found for <b>${searchTerm}</b>. <br>Please try a different search query.</div>`;
      predictiveSearchResultsContainer.innerHTML = message;
      document.querySelectorAll('.view-all').forEach(button => {
        button.classList.add('hidden');
      });
    } else {
      document.querySelectorAll('.view-all').forEach(button => {
        button.classList.remove('hidden');
      });
    }

    // Update the search count
    this.updateSearchCount(totalResults);
  }

  updateSearchCount(totalResults) {
    document.querySelectorAll('.search-count').forEach(searchCount => {
      searchCount.textContent = ` (${totalResults})`;
    });
  }

  open(searchTerm) {
    this.spinner.classList.add('hidden');
    this.searchButton.classList.remove('hidden');
    this.wrapper.setAttribute('open', '');
    this.form.setAttribute('open', '');
    document.documentElement.classList.add('search-open');
    this.closeButtons = this.wrapper.querySelectorAll('.search__close-button');
    this.closeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        this.form.removeAttribute('open');
        this.close();
      });
    });
  }

  close() {
    this.wrapper.removeAttribute('open');
    this.searchButton.classList.remove('hidden');
    this.spinner.classList.add('hidden');
    document.documentElement.classList.remove('search-open');
  }

  updateSearchHistory(searchTerm) {
    const resultsList = this.predictiveSearchResults;

    if (!resultsList) {
      console.log('No results list found.');
      return;
    }

    // Remove any existing event listener to prevent multiple attachments
    if (this.resultsListClickHandler) {
      resultsList.removeEventListener('click', this.resultsListClickHandler);
    }

    // Define the click handler
    this.resultsListClickHandler = (event) => {
      const link = event.target.closest('a');
      if (link) {
        // Optionally, remove the preventDefault in production
        // event.preventDefault();

        console.log('Clicked link:', link.href);

        // Update search history
        this.recordSearchTerm(searchTerm);

        // Allow default action (navigation)
      }
    };

    // Attach the event listener
    resultsList.addEventListener('click', this.resultsListClickHandler);
  }
  recordSearchTerm(searchTerm) {
    // Retrieve the current search history from localStorage
    let searchHistory = JSON.parse(localStorage.getItem('searchHistory')) || [];

    // Normalize the search term (e.g., lowercase)
    const normalizedSearchTerm = searchTerm.toLowerCase();

    // Remove the term if it already exists in the history
    searchHistory = searchHistory.filter(term => term.toLowerCase() !== normalizedSearchTerm);

    // Add the new search term to the front of the array
    searchHistory.unshift(searchTerm);

    // Ensure the history only contains the last 3 search terms
    if (searchHistory.length > 3) {
      searchHistory.pop();
    }

    // Update the localStorage with the new history
    localStorage.setItem('searchHistory', JSON.stringify(searchHistory));

    console.log('Updated Search History:', searchHistory);
  }

  renderSearchHistory() {
    const searchHistoryContainer = this.predictiveSearchResults.querySelector('.search-history');

    if (!searchHistoryContainer) {
      console.error('No search history container found.');
      return;
    }

    // Retrieve the search history from localStorage
    const searchHistory = JSON.parse(localStorage.getItem('searchHistory')) || [];

    if (searchHistory.length === 0) {
      searchHistoryContainer.style.display = 'none';
      return;
    } else {
      searchHistoryContainer.style.display = 'block';
    }

    // Clear any existing history items before rendering
    searchHistoryContainer.innerHTML = '';

    // Build the HTML string using template literals
    searchHistory.forEach(term => {
      const listItem = document.createElement('li');
      listItem.className = 'predictive-search__linklist-item search-history-item';

      listItem.innerHTML = `
        <a class="predictive-search__linklist-link" href="/search?q=${encodeURIComponent(term)}&filter.p.m.default.view=1">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor">
            <path d="M480-120q-138 0-240.5-91.5T122-440h82q14 104 92.5 172T480-200q117 0 198.5-81.5T760-480q0-117-81.5-198.5T480-760q-69 0-129 32t-101 88h110v80H120v-240h80v94q51-64 124.5-99T480-840q75 0 140.5 28.5t114 77q48.5 48.5 77 114T840-480q0 75-28.5 140.5t-77 114q-48.5 48.5-114 77T480-120Zm112-192L440-464v-216h80v184l128 128-56 56Z"/>
          </svg>
          <span>${term}</span>
        </a>
        <div class="close tap-area">
          <svg focusable="false" width="10" height="10" class="icon icon--close" viewBox="0 0 14 14">
            <path d="M13 13L1 1M13 1L1 13" stroke="currentColor" stroke-width="2" fill="none"></path>
          </svg>
        </div>`;

      // Add event listener for the close button
      listItem.querySelector('.close').addEventListener('click', () => {
        // Remove the term from localStorage
        this.removeSearchTerm(term);
        // Remove the list item from the DOM
        listItem.remove();
      });

      // Append the list item to the container
      searchHistoryContainer.appendChild(listItem);
    });
  }

  // Helper function to remove a term from search history in localStorage
  removeSearchTerm(term) {
    let searchHistory = JSON.parse(localStorage.getItem('searchHistory')) || [];

    // Remove the selected term from the history array
    searchHistory = searchHistory.filter(item => item !== term);

    // Update localStorage with the new search history array
    localStorage.setItem('searchHistory', JSON.stringify(searchHistory));
  }


  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);

// const headerWrapper = document.querySelector('.header__wrapper');
// const searchBar = document.querySelector('.header__search-bar');
// const searchBreak = document.querySelector('.searchBreak');

// function handleResize() {
//   const searchBarWidth = searchBar.getBoundingClientRect().width;
//   if (searchBarWidth < 800) {
//     headerWrapper.classList.add('header-shrink');
//   } else {
//     headerWrapper.classList.remove('header-shrink');
//   }
// }

// // Initial call to handleResize
// handleResize();

// // Add event listener for resize events on the window
// window.addEventListener('resize', handleResize);